import { getSession, setSession, devAlert } from '@/utils/index'
import { 
    queryVisitors, 
    addVisitor, 
    modifyVisitor,
    getSpecialTypes,
    getSpecialList,
    addSpecialVisitor,
    updateSpecialVisitor,
    getVisitorConfig
} from '@/api/visitor'
import { addOftenVisitor, deleteOftenVisitor, oftenVisitorList, updateOftenVisitor } from '../../api/visitor';

let vid = 0;
const state = {
    openid: getSession('visitor/openid'),
    projectId: getSession('visitor/projectId') || '',
    resident: getSession('visitor/resident') || {},
    visitors: getSession('visitor/visitors') || [],
    records: getSession('visitor/records') || [],
    visitorTypes: getSession('visitor/visitorTypes') || [],
    merchant: getSession('visitor/merchant') || {},
    timeInfo: getSession('visitor/timeInfo') || {},
    oftenVisitorList: getSession('visitor/oftenVisitorList') || [],
    houseInfo: getSession('visitor/houseInfo') || {},
    projectConfig :getSession('visitor/projectConfig') || {}
}

const getters = {
    getVisitorByField: state => (val, field='id') => {
        let visitor = state.visitors.find(item => item[field] == val) || {};
        return visitor;
    },
    getRecordById: state => (val) => {
        let record = state.records.find(item => item.id == val) || {};
        return record;
    },
    getVisitorType: state => id => {
        return state.visitorTypes.find(item => item.id == id) || {};
    },
    getOftenVisitorById: state => id => {       
        return state.oftenVisitorList.find(item => item.id === id) || {}
    },
    supportVisitorCar: state => {
        return state.projectConfig.support_visitor_car || false
    },
    supportFaceUpload: state => {
        return state.projectConfig.support_face_upload || false
    }    
}

const mutations = {
    SET_OPENID(state, openid) {
        setSession('visitor/openid', openid);
        state.openid = openid;
    },
    SET_PROJECIID(state, projectId) {
        setSession('visitor/projectId', projectId);
        state.projectId = projectId;
    },
    SET_RESIDENT(state, resident) {
        setSession('visitor/resident', resident);
        state.resident = resident;
    },
    ADD_VISITOR(state, visitor) {
        // if (!visitor.id) {
        //     visitor.id = vid++;
        // }
        state.visitors=[visitor];
        setSession('visitor/visitors', state.visitors);
    },
    SET_VISITOR(state, visitor) {
        let index = state.visitors.findIndex(item => item.id === visitor.id);
        state.visitors.splice(index, 1, visitor);
        setSession('visitor/visitors', state.visitors);
    },
    DEL_VISITOR(state, visitorId) {
        let index = state.visitors.findIndex(item => item.id === visitorId);
        state.visitors.splice(index, 1);
        setSession('visitor/visitors', state.visitors);
    },
    CLEAR_VISITORS(state) {
        state.visitors = [];
        setSession('visitor/visitors', []);
    },
    SET_OFTEN_VISITORS(state, list) {
        state.oftenVisitorList = list
        setSession('visitor/oftenVisitorList', state.oftenVisitorList)
    },
    INSERT_OFTEN_VISITOR(state, visitor) {
        state.oftenVisitorList.push(visitor)
        setSession('visitor/oftenVisitorList', state.oftenVisitorList)
    },
    MODIFY_OFTEN_VISITOR(state, visitor) {
        let index = state.oftenVisitorList.findIndex(item => item.id == visitor.id)
        index> -1 && state.oftenVisitorList.splice(index, 1, visitor)
        setSession('visitor/oftenVisitorList', state.oftenVisitorList)
    },
    REMOVE_OFTEN_VISITOR(state, id) {
        let index = state.oftenVisitorList.findIndex(item => item.id == id)
        index> -1 && state.oftenVisitorList.splice(index, 1)
        setSession('visitor/oftenVisitorList', state.oftenVisitorList)
    },
    SET_RECORDS(state, records) {
        state.records = records;
        setSession('visitor/records', records);
    },
    SET_HOUSEINFO(state, houseInfo) {
        state.houseInfo = houseInfo;
        setSession('visitor/houseInfo', houseInfo)
    },
    SET_PROJECT_CONFIG(state, projectConfig) {
        state.projectConfig = projectConfig
        setSession('visitor/projectConfig', projectConfig)
    },
    SET_TIMEINFO(state, timeInfo) {
        state.timeInfo = timeInfo;
        setSession('visitor/timeInfo', timeInfo);
    },
    CLEAR_TIMEINFO(state) {
        state.timeInfo = {};
    },
    SET_VISITOR_TYPES(state, types) {
        state.visitorTypes = types;
        setSession('visitor/visitorTypes', types);
    },
    SET_MERCHANT(state, merchant) {
        state.merchant = merchant;
        setSession('visitor/merchant', merchant);
    },
    CLEAR_MERCHANT(state) {
        state.merchant = [];
        setSession('visitor/merchant', []);
    },
}


const actions = {
    queryRecords({ commit }, payload) {
        return new Promise((resolve, reject) => {
            queryVisitors(payload.projectId, payload.openid).then(data => {
                const list = data.list || [];

                commit('SET_RECORDS', list);
                resolve(list);
            }).catch(err => {
                commit('SET_RECORDS', []);
                reject(err);
            });
        });
    },
    doAddVisitor({dispatch}, payload) {
        const {
            projectId,
            visitor,
            reload=true,
            isNewSeeFlag
        } = payload;

        return new Promise((resolve, reject) => {
            addVisitor(projectId, visitor,isNewSeeFlag).then(data => {
                if (reload) {
                    dispatch('queryRecords', {projectId, openid: visitor.open_id});
                }
                
                resolve(data);
            }).catch(err => {
                reject(err);
            });
        });
    },
    updateVisitor({dispatch}, payload) {
        const {
            projectId,
            visitorId,
            openid,
            visitor,
            reload=true
        } = payload;

        return new Promise((resolve, reject) => {
            modifyVisitor(projectId, visitorId, visitor).then(data => {
                if (reload) {
                    dispatch('queryRecords', {projectId, openid});
                }
                
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    querySpecialTypes({ commit }, payload) {
        return new Promise((resolve, reject) => {                        
            getSpecialTypes(payload.projectId, payload.specialFlag).then(data => {
                const list = data.list || [];

                commit('SET_VISITOR_TYPES', list);
                resolve(list);
            }).catch(err => {
                reject(err);
            });
        });
    },
    // 获取项目访客配置
    queryProjectConfig({commit}, payload) {
        return new Promise((resolve, reject) => {                        
            getVisitorConfig(payload.projectId).then(data => {               
                commit('SET_PROJECT_CONFIG', data);
                resolve(data);
            }).catch(err => {
                reject(err);
            });
        });
    },
    querySpecialList({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            getSpecialList(state.projectId, state.openid, payload.merchantFlag).then(data => {
                const list = data.list || [];

                commit('SET_RECORDS', list);
                resolve(list);
            }).catch(err => {
                commit('SET_RECORDS', []);
                reject(err);
            });
        });
    },
    doAddSpecialVisitor({dispatch}, payload) {
        const {
            projectId,
            visitor
        } = payload;

        return new Promise((resolve, reject) => {
            addSpecialVisitor(projectId, visitor).then(data => {
                dispatch('querySpecialList', {merchantFlag: visitor.merchant_flag});
                resolve(data);
            }).catch(err => {
                reject(err);
            });
        });
    },
    doUpdateSpecialVisitor({dispatch}, payload) {
        const {
            projectId,
            visitorId,
            merchantFlag,
            visitor
        } = payload;

        return new Promise((resolve, reject) => {
            updateSpecialVisitor(projectId, visitorId, visitor).then(data => {
                dispatch('querySpecialList', { merchantFlag: merchantFlag || visitor.merchant_flag });
                resolve(data);
            }).catch(err => {
                reject(err);
            });
        });
    },
    // 常用访客列表
    queryOftenVisitorList({commit}, payload) {
        // const {search, resident_id, open_id, method} = payload
        return new Promise((resolve, reject) => {
            oftenVisitorList(payload).then(res => {
                const {list} = res || []
                commit('SET_OFTEN_VISITORS', list)
                resolve(list)
            }).catch(err => {
                // reject(err)
                commit('SET_OFTEN_VISITORS', [])
                resolve([])
            })
        })
    },
    // 删除常用访客
    deleteOftenVisitor({commit}, payload) {
        let id = typeof payload === 'string' ? payload : payload.id
        return new Promise((resolve, reject) => {
            deleteOftenVisitor(id).then(res => {
                commit('REMOVE_OFTEN_VISITOR', id)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 修改常用访客
    updateOftenVisitor({commit}, payload) {
        return new Promise((resolve, reject) => {
            updateOftenVisitor(payload).then(res => {
                commit('MODIFY_OFTEN_VISITOR', payload)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 添加常用访客
    addOftenVisitor({commit}, payload) {
        return new Promise((resolve, reject) => {
            addOftenVisitor(payload).then(res => {
                const {id} = res
                commit('INSERT_OFTEN_VISITOR', {...payload, id})
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/visitor.js